// extracted by mini-css-extract-plugin
export default {"l":"_7fa50eca77"};